var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 30,
    viewBox: "0 0 118 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 80             L30 20             Q40 0 50 20             Q60 0 70 20             Q80 0 90 20             Q100 0 110 20             L130 80             M130 20             L150 80             L170 20             L170 80             L190 20             L190 80             M210 80             L230 20             Q240 0 250 20             Q260 0 270 20             L290 80",
    stroke: "white",
    strokeWidth: 5,
    fill: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.fd86303313dfaabdf4899341f160a371.svg";
export { ForwardRef as ReactComponent };